import { useId } from 'react';
import './OrientacaoDeImpressao.css';

/**
 * Como imprimir e colar (qr-code.md §14.3).
 *
 * Fica na tela, ao lado do botão, porque quem imprime raramente leu a spec, e
 * cada item aqui é uma causa conhecida de leitura falha no inventário: reflexo
 * de laminação brilhante em ângulo baixo, térmica direta que desbota, etiqueta
 * dobrada em quina, volume empilhado com a única etiqueta virada para dentro.
 */
export function OrientacaoDeImpressao() {
  const idTitulo = useId();

  return (
    <section className="cartao orientacao-impressao" aria-labelledby={idTitulo}>
      <div className="cartao__cabecalho">
        <h2 className="cartao__titulo" id={idTitulo}>
          Como imprimir e colar
        </h2>
      </div>
      <ul className="cartao__corpo orientacao-impressao__lista">
        <li>
          <strong>Material fosco</strong>, sem laminação brilhante: o reflexo é o que mais atrapalha
          a leitura em ângulo.
        </li>
        <li>
          <strong>Transferência térmica com ribbon de resina.</strong> Térmica direta desbota.
        </li>
        <li>
          Na janela de impressão: <strong>escala 100%</strong>, sem margens e sem ajustar à página —
          o QR precisa sair com o tamanho escolhido. Para guardar, &quot;Salvar como PDF&quot;.
        </li>
        <li>
          Cole em <strong>superfície plana</strong>, nunca em quina ou curva, sem cobrir a borda
          branca em volta do QR.
        </li>
        <li>
          Em volumes empilhados, cole em <strong>duas faces</strong> (frente e lateral): use 2
          cópias por produto.
        </li>
      </ul>
    </section>
  );
}
